const realTime = (root: string) => () => {
  return `${root}/real-time`;
};

const analyse = (root: string) => () => {
  return `${root}/analyse`;
};

const monitoringExport = (root: string) => {
  return `${root}/export`;
};

export const monitoringRoutes = (root: string) => ({
  root,
  realTime: realTime(root),
  analyse: analyse(root),
  export: monitoringExport(root),
});
